import { ClipboardList } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Forms — Lead-capture forms and embeds that create leads automatically.
 * Foundation F8 · Roadmap item 1
 * STATUS: registered stub. The feature team replaces ./page with the real screens.
 */
export default defineFeature({
  key: "forms",
  title: "Forms",
  entities: ["form"],
  routes: [
    { path: "forms", lazy: () => import("./page") },
    { path: "forms/:id", lazy: () => import("./page") },
  ],
  publicRoutes: [
    { path: "/f/:slug", lazy: () => import("./public") },
  ],
  nav: [
    {
      label: "Forms",
      to: "/forms",
      icon: ClipboardList,
      group: "sales",
      order: 30,
      permission: "forms:manage",
      description: "Lead capture forms and embeds",
    },
  ],
  quickCreate: [
    {
      key: "forms",
      label: "Form",
      icon: ClipboardList,
      to: "/forms?new=1",
      permission: "forms:manage",
      description: "Publish a lead capture form",
    },
  ],
});
